<div
  *ngIf="colVm.columnType === Types.SectionColumnProductInfoType.Stock"
  class="product-column-general product-quantity-in-stock"
  [style.visibility]="section?.collapseContent || rowVm.collapseContent ? 'collapse' : ''"
  [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async"
  [style.margin-right]="menu | productMenuBasicMethod: 'getSectionBorderMarginSize'">
  {{ rowVm | sectionRowViewModelBasicMethod: 'getQuantityInStock' }}
</div>
